var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.133 19.861c2.219-1.792 3.549-3.42 3.549-6.298v.003c0-3.367-2.328-5.703-6.263-5.703-4.27 0-7.318 2.498-7.262 8.472h-7.153C9.836 7.865 15.217 2 24.473 2 34.007 2 38 7.266 38 13.183c0 5.21-2.44 7.926-5.823 10.698l-3.158 2.551c-1.553 1.246-2.051 1.738-2.051 3.638v2.443h-6.544v-3.475c0-3.476.777-4.289 3.716-6.733l2.993-2.444Zm.833 17.809v7.603h-8.593V37.67h8.593Z"
  })));
};
export default SvgQuestion;